import { onDocumentEvent } from '@app/utils/domHelpers'
import $ from 'jquery'

const queryAndSubmitByData = (e) => {
  e.preventDefault()

  const triggerElement = e.target
  const formSelector = triggerElement.dataset.target
  const formElement = document.querySelector(formSelector)

  if (!formElement) {
    return
  }

  triggerElement.disabled = true
  $(formElement).submit()

  setTimeout(() => {
    triggerElement.disabled = false
  }, 1500)
}

onDocumentEvent(
  document,
  'mouseup',
  '[data-behaviour="submit-trigger"]',
  queryAndSubmitByData
)
